// EthereumContext.js
import React from 'react';

const EthereumContext = React.createContext();

export default EthereumContext;